//manage token

import {isResponseCancelled} from "./apiResponse"

export const getCartToken = () => {
    return localStorage.getItem('token')
}

export const updateToken = (value) => {
    localStorage.setItem('token', value)
}

export const removeToken = () => {
    localStorage.removeItem('token')
}

export const removeTokenWhenFatalError = (errorResponse) =>{
    if(!isResponseCancelled(errorResponse)){
        if(errorResponse && errorResponse.status!==400){
            removeToken()
        }else{
            removeToken()
        }
    }
}